const billingRunStatuses = ['pending', 'billed', 'nothing_due', 'failed']

export const billingRuns: TableModule = {
    name: "billingRuns",
    route: "spa.system.billingRuns",
    defaultOrder: {
        column: "billing_runs.created_at",
        direction: "desc"
    },
    columns: [
        {
            name: "created_at",
            sortBy: "billing_runs.created_at",
            mobile: true,
            sortable: true,
            width: "w-[140px]"
        },
        {
            name: "organisation_name",
            sortBy: "organisations.name",
            mobile: true,
            sortable: true
        },
        {
            name: "kind",
            sortBy: "billing_runs.period",
            sortable: true,
            breakpoint: "md",
        },
        {
            name: "status",
            sortBy: "billing_runs.status",
            mobile: true,
            sortable: true,
            truncate: false,
            width: "w-[56px] sm:w-[160px]"
        },
        {
            name: "invoice_number",
            sortBy: "billings.invoice_number",
            sortable: true,
            breakpoint: "md",
        },
        {
            name: "error",
            truncate: false,
            breakpoint: "lg",
        },
    ],
    filters: [
        {
            name: "status",
            column: "customFilterStatus",
            type: "select",
            options: () => billingRunStatuses.map((status) => ({
                value: status,
                label: useNuxtApp().$i18n.t(`billingRuns.statuses.${status}`)
            }))
        },
        {
            name: "organisation_name",
            column: "organisations.name",
            type: "string"
        },
        {
            name: "period",
            column: "billing_runs.period",
            type: "string",
            reduced: true
        },
    ],
    quickFilters: [
        {
            name: "qf_onlyFailed",
            column: "customFilterStatus",
            value: ["failed"],
            operator: "="
        }
    ],
    tools: []
}
